import React from 'react';
import ErrorIcon from 'react-icons/lib/md/do-not-disturb-off';

import {
    CardBlock
} from 'reactstrap';
const ComponentPageError = ({error}) => (
    <div>
        <CardBlock className="table-responsive">
            <div className="row">
                <div className="col-md-12">
                    <div className="text-center">
                        <ErrorIcon size="70" color="#d50000"/>
                    </div>
                    <h5 className="text-center mt-2">
                        {error}
                    </h5>
                </div>
            </div>
        </CardBlock>
    </div>
);

export default ComponentPageError;


// WEBPACK FOOTER //
// ./src/views/utils/component-page.error.js